import { render } from "./BudgetDashboard.vue?vue&type=template&id=33b33a6c&scoped=true"
import script from "./BudgetDashboard.vue?vue&type=script&lang=js"
export * from "./BudgetDashboard.vue?vue&type=script&lang=js"

import "./BudgetDashboard.vue?vue&type=style&index=0&id=33b33a6c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33b33a6c"]])

export default __exports__